import isJSON from "./isJSON"

const getJSONFromStorage = ()  => {
  return (typeof localStorage !== 'undefined') && isJSON(localStorage.getItem("quizJson")) ? JSON.parse(localStorage.getItem("quizJson")) : null
}

export default getJSONFromStorage
